import { render, staticRenderFns } from "./entry-arrow.vue?vue&type=template&id=322d824c&"
import script from "./entry-arrow.vue?vue&type=script&lang=js&"
export * from "./entry-arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports